module.exports = __webpack_public_path__ + "img/delete.ed66ca33.png";